// extracted by mini-css-extract-plugin
export default {"DraggableCard":"bfl_a"};